import Pages from '@pages';
import { enableParental } from '../../store/slices/user.slice';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';
import { clearPauseAd } from '@shared/store/slices/ads.slice';

function goToZapper() {
  store.dispatch(enableParental());
  store.dispatch(clearPauseAd());
  store.dispatch(
    pushRoute({
      route: {
        Page: Pages.ZAPPER,
        overwrite: true,
      },
    })
  );
}

export default goToZapper;
